import valueLink from './react-link-state';

export default function(me,path) {
  return {
    removeByIndex:(index)=>{
      let cur=valueLink(me,path).value;
      cur.splice(index,1);
      valueLink(me,path).requestChange(cur);
    },
    push:(item)=>{
      let cur=valueLink(me,path).value;
      cur.push(item);
      valueLink(me,path).requestChange(cur);
    },
    valueLink:()=>{
      console.log('path',path,valueLink(me,path));
      return valueLink(me,path);
    },
    ordinary: {
      value:valueLink(me,path).value,
      onChange:(e)=>{
        valueLink(me,path).requestChange(e.target.value)
      }
    },
    checkbox:{
      checked:valueLink(me,path).value==='1'?true:false,
      onChange:(e)=>{
        console.log('e.target',e.target);
        valueLink(me,path).requestChange(e.target.checked===true?'1':'0');
      }
    }
  }
}
